import React from 'react';
import { Link } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

import AddIcon from '@mui/icons-material/AddOutlined';
import TaskIcon from '@mui/icons-material/TaskOutlined';
import Button from '@ui-lib/components/Button';
import { createSx } from '@ui-lib/utils';
import { Header } from '../../../components/Header';

const sx = createSx({
  root: {
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    backgroundColor: 'background.default',
    height: '100%',
    width: '100%',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    spacing: 2,
  }

});

export const BolCreatedPageSuccess = () => {
  return (
    <Stack sx={sx.root}>
      <Header />

      <Stack sx={sx.content} >
        <TaskIcon fontSize='large' color='success' />
        <Typography variant='subtitle1Bold' gutterBottom textAlign='center'>
          BOL added successfully!
        </Typography>
        <Typography variant='body2' textAlign='center'>
          Your BOL has been saved and linked to the QR code.
        </Typography>

        <Link to='/create' replace>
          <Button startIcon={<AddIcon />} variant='tonal' size='large' sx={{ mt: 2 }}>
            Add another BOL
          </Button>
        </Link>
      </Stack>

    </Stack>
  );
};
